import * as THREE from "three";
import {Group} from "three";

export default class DtDecor extends Group {
    width; height; depth;
    decor;
    constructor(width, height, depth) {
        super();
        this.depth = depth;
        this.width = width;
        this.height = height;
        this.textureLoader = new THREE.TextureLoader();
        this.drawWalls();
    }
    drawWalls() {

        // load a texture
        const floorTexture = this.loadTexture("floor")
        const floorMaterial = new THREE.MeshStandardMaterial( { map: floorTexture, side: THREE.DoubleSide } );

        const floor = new THREE.PlaneGeometry(this.width * 4, this.depth);
        const floorWall = new THREE.Mesh(floor, floorMaterial);
        floorWall.translateZ(this.depth/2);
        floorWall.translateX(this.width/2);
        floorWall.rotateX(THREE.MathUtils.degToRad(90));
        floorWall.receiveShadow = true;
        this.add(floorWall);

        // load a texture
        const wallTexture = this.loadTexture("wall");
        const wallMaterial = new THREE.MeshStandardMaterial( { map: wallTexture, side: THREE.DoubleSide } );

        // back wall
        const back = new THREE.PlaneGeometry(this.width*4, this.height*2);
        back.translate(this.width/2, this.height, 0);
        const backWall = new THREE.Mesh(back, wallMaterial);
        backWall.receiveShadow = true;
        this.add(backWall);

        // left wall
        const left = new THREE.PlaneGeometry(this.depth, this.height*2);
        left.translate(0, this.height, 0);
        const leftWall = new THREE.Mesh(left, wallMaterial);
        leftWall.translateX(-(this.width + (this.width/2)));
        leftWall.translateZ(this.depth/2);
        leftWall.receiveShadow = true;
        leftWall.rotateY(THREE.MathUtils.degToRad(90));
        this.add(leftWall);

        // right wall
        const right = new THREE.PlaneGeometry(this.depth, this.height*2);
        right.translate(0, this.height, 0);
        const rightWall = new THREE.Mesh(right, wallMaterial);
        rightWall.translateX(this.width*2.5);
        rightWall.translateZ(this.depth/2);
        rightWall.receiveShadow = true;
        rightWall.rotateY(THREE.MathUtils.degToRad(90));
        this.add(rightWall);
    }

    loadTexture(type = 'floor') {
        let fileName = sessionStorage.getItem(`${type}Texture`);

        let texture = this.textureLoader.load(`/background_images/${type}/${fileName}.webp`);

        texture.wrapS = THREE.RepeatWrapping;
        texture.wrapT = THREE.RepeatWrapping;

        if(sessionStorage.getItem(`${type}TextureRescale`) === "repeat") {
            texture.repeat.set(3,1);
        }

        return texture;
    }
}